// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__21BtY","deleteIcon":"Tag_deleteIcon__14Obm"};